import { fromJS, List } from 'immutable';

import {
  SHOW_NAV_MENU,
  HIDE_NAV_MENU,
  ROOT_CLASSES_ADD,
  ROOT_CLASSES_REMOVE,
  UTM_COOKIES_SET
} from '../../actions/UI';


const initialState = fromJS({
  rootClasses: [],
  utmCookiesSet: false,
});

export default function uiInternal(state = initialState, action = {}) {
  switch (action.type) {

    case SHOW_NAV_MENU: {
      return state.set('showNavMenu', true);
    }

    case HIDE_NAV_MENU: {
      return state.set('showNavMenu', false);
    }

    case UTM_COOKIES_SET: {
      return state.set('utmCookiesSet', true);
    }

    case ROOT_CLASSES_ADD: {
      const classes = List(
        typeof action.classes === 'string'
          ? action.classes.split(' ')
          : action.classes,
      );

      // Filter on those that we have to add.
      const newClasses = classes.filter((item) => {
        const index = state.get('rootClasses').findIndex((c) => c === item);
        return index === -1;
      });

      return state
        .update('rootClasses', (list) => list.merge(newClasses));
    }

    case ROOT_CLASSES_REMOVE: {
      const classes = List(
        typeof action.classes === 'string'
          ? action.classes.split(' ')
          : action.classes,
      );

      return state
        .update('rootClasses', (list) => list.filter((item) => {
          const index = classes.findIndex((c) => c === item);
          return index === -1;
        }));
    }

    default:
      return state;
  }
}
